;(function () {
	'use strict'

	function initCVS(section) {
		var playBtn = section.querySelector('[data-cvs-play-btn]')
		var mediaWrap = section.querySelector('[data-cvs-media-wrap]')
		var iframe = section.querySelector('[data-cvs-iframe]')
		var video = section.querySelector('[data-cvs-video]')
		var clickCapture = section.querySelector('[data-cvs-click-capture]')
		if (!playBtn || !mediaWrap || !iframe) return

		var isLoaded = false
		var isPlaying = false

		function isMobile() {
			return window.matchMedia('(max-width: 749px)').matches
		}

		var fsParent = null
		var fsNextSibling = null

		function enterFullscreen() {
			if (!isMobile()) return
			// Teleport to <body> — an ancestor section may have a transform/filter
			// (scroll-reveal animations etc.) which creates a containing block and
			// traps position:fixed inside it instead of the real viewport.
			fsParent = mediaWrap.parentNode
			fsNextSibling = mediaWrap.nextSibling
			document.body.appendChild(mediaWrap)
			mediaWrap.classList.add('is-cvs-fullscreen')
			document.body.classList.add('cvs-scroll-lock')
		}

		function exitFullscreen() {
			mediaWrap.classList.remove('is-cvs-fullscreen')
			document.body.classList.remove('cvs-scroll-lock')
			if (fsParent) {
				fsParent.insertBefore(mediaWrap, fsNextSibling)
				fsParent = null
				fsNextSibling = null
			}
		}

		function detectVideo(url) {
			var match
			// youtu.be/ID
			match = url.match(/youtu\.be\/([^?&]+)/)
			if (match) return { type: 'youtube', embed: 'https://www.youtube.com/embed/' + match[1] }
			// youtube.com/watch?v=ID
			match = url.match(/[?&]v=([^?&]+)/)
			if (match) return { type: 'youtube', embed: 'https://www.youtube.com/embed/' + match[1] }
			// already a youtube embed URL
			if (/youtube\.com\/embed\//.test(url)) return { type: 'youtube', embed: url }
			// vimeo.com/ID
			match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
			if (match) return { type: 'vimeo', embed: 'https://player.vimeo.com/video/' + match[1] }
			// already a vimeo player embed URL
			if (/player\.vimeo\.com\/video\//.test(url)) return { type: 'vimeo', embed: url }
			// not a known platform — treat as a direct video file
			return { type: 'file', embed: url }
		}

		var info = detectVideo(iframe.getAttribute('data-cvs-src'))
		var playCmd = info.type === 'youtube' ? 'playVideo' : 'play'
		var pauseCmd = info.type === 'youtube' ? 'pauseVideo' : 'pause'

		// Hide whichever element isn't used for this video type
		if (info.type === 'file') {
			iframe.style.display = 'none'
		} else if (video) {
			video.style.display = 'none'
		}

		function sendCommand(func) {
			try {
				if (info.type === 'youtube') {
					iframe.contentWindow.postMessage(
						JSON.stringify({ event: 'command', func: func, args: '' }),
						'*'
					)
				} else if (info.type === 'vimeo') {
					iframe.contentWindow.postMessage(JSON.stringify({ method: func }), '*')
				}
			} catch (e) {}
		}

		function setPlaying() {
			isPlaying = true
			mediaWrap.classList.add('is-playing')
			playBtn.setAttribute('aria-label', 'Pause video')
		}

		function setPaused() {
			isPlaying = false
			mediaWrap.classList.remove('is-playing')
			playBtn.setAttribute('aria-label', 'Play video')
		}

		function play() {
			if (info.type === 'file') {
				if (video) {
					if (!isLoaded) {
						video.src = info.embed
						isLoaded = true
					}
					video.play().catch(function () {})
				}
			} else {
				if (!isLoaded) {
					iframe.src = info.embed + '?autoplay=1&enablejsapi=1&controls=0&origin=' + encodeURIComponent(window.location.origin)
					isLoaded = true
				} else {
					sendCommand(playCmd)
				}
			}
			setPlaying()
			enterFullscreen()
		}

		function pause() {
			if (info.type === 'file') {
				if (video) video.pause()
			} else {
				sendCommand(pauseCmd)
			}
			setPaused()
			exitFullscreen()
		}

		// Sync state with YouTube's own events (e.g. video ends naturally)
		window.addEventListener('message', function (event) {
			try {
				var data = JSON.parse(event.data)
				if (data.event !== 'onStateChange') return
				// YouTube states: -1 unstarted, 0 ended, 1 playing, 2 paused
				if (data.info === 0 || data.info === 2) {
					if (isPlaying) setPaused()
				} else if (data.info === 1) {
					if (!isPlaying) setPlaying()
				}
			} catch (e) {}
		})

		// Sync state with the native <video> element (direct file playback)
		if (video) {
			video.addEventListener('ended', function () {
				if (isPlaying) setPaused()
			})
			video.addEventListener('pause', function () {
				if (isPlaying) setPaused()
			})
			video.addEventListener('play', function () {
				if (!isPlaying) setPlaying()
			})
		}

		playBtn.addEventListener('click', function () {
			if (isPlaying) {
				pause()
			} else {
				play()
			}
		})

		if (clickCapture) {
			clickCapture.addEventListener('click', function () {
				if (isPlaying) {
					pause()
				} else {
					play()
				}
			})
		}
	}

	function init() {
		document.querySelectorAll('.custom-video-section').forEach(function (section) {
			initCVS(section)
		})
	}

	document.addEventListener('DOMContentLoaded', init)

	document.addEventListener('shopify:section:load', function (e) {
		var section = e.target.querySelector('.custom-video-section')
		if (section) initCVS(section)
	})
})()
